import checkout from "layouts/sub-organization/components/sub-organization-details/schemas/subOrganizationForm";

const {
  formField: { subOrganizationKey, country, city, district, address, phone, email, organization },
} = checkout;

export default {
  [subOrganizationKey.name]: "",
  [country.name]: "",
  [city.name]: "",
  [district.name]: "",
  [address.name]: "",
  [phone.name]: "",
  [email.name]: "",
  [organization.name]: null,
};
